var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.dataOrigin.state === 'inactive')?_c('div',{staticClass:"inactive"}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }